import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the mailConfiguration state domain
 */

const selectMailConfigurationDomain = (state) =>
  state.get("mailConfiguration", initialState)

/**
 * Other specific selectors
 */
export const makeSelectConfiguration = () =>
  createSelector(selectMailConfigurationDomain, (state) =>
    state.get("configuration")
  )

export const makeSelectIsLoadingConfiguration = () =>
  createSelector(selectMailConfigurationDomain, (state) =>
    state.get("isLoadingConfiguration")
  )

export const makeSelectImages = () =>
  createSelector(selectMailConfigurationDomain, (state) => state.get("images"))

export const makeSelectIsLoadingImages = () =>
  createSelector(selectMailConfigurationDomain, (state) =>
    state.get("isLoadingImages")
  )

export const makeSelectLogo = () =>
  createSelector(selectMailConfigurationDomain, (state) => state.get("logo"))

export const makeSelectIsLoadingLogo = () =>
  createSelector(selectMailConfigurationDomain, (state) =>
    state.get("isLoadingLogo")
  )
/**
 * Default selector used by MailConfiguration
 */

const makeSelectMailConfiguration = () =>
  createSelector(selectMailConfigurationDomain, (substate) => substate.toJS())

export default makeSelectMailConfiguration
export { selectMailConfigurationDomain }
